import Default from './Default';
import Lista from './Lista';

const Comunicado = Default;

export default Comunicado;
export const ComunicadoLista = Lista;
